module.exports = __webpack_public_path__ + "static/img/11.0b69c7d9.jpg";